<div class="homescreen flex flex-col page-size items-center space-between">
  <div class="w-full text-center pt-20">
    <span class="title text-8xl">re:Form Kingdom</span>
  </div>

  <div class="mt-8">
    @if (savefileFailureText(); as failText) {
      <div
        role="alert"
        class="alert alert-error flex flex-col gap-2 w-full min-w-[400px]"
      >
        <span>{{ failText }}</span>
        <span class="text-sm">It has not been overwritten.</span>
      </div>
    }

    @if (showBackupsAvailable()) {
      <div role="alert" class="alert alert-info w-full">
        <span>No savefile is active, but backups of an earlier one exist.</span>
      </div>
    }
  </div>

  <div
    class="flex flex-col gap-2 min-w-[300px] max-w-[300px] items-center justify-center flex-1"
  >
    @if (savefileFailureText()) {
      <button
        class="btn btn-neutral btn-block mt-2"
        (click)="openSavefileSettings()"
        appAnalyticsClick="Meta:Play:RecoverSavefile"
        appSfx="ui-click"
        [sfxTrigger]="['click', 'hover']"
      >
        Recover Savefile
      </button>
    }

    @if (showBackupsAvailable()) {
      <button
        class="btn btn-neutral btn-block mt-2"
        (click)="openSavefileSettings()"
        appAnalyticsClick="Meta:Play:RestoreBackup"
        appSfx="ui-click"
        [sfxTrigger]="['click', 'hover']"
      >
        Restore a Backup
      </button>
    }

    @if (hasStartedGame()) {
      <button
        class="btn btn-primary btn-block"
        (click)="resumeGame()"
        appAnalyticsClick="Meta:Play:Resume"
        appSfx="ui-click"
        [sfxOffset]="1"
        [sfxTrigger]="['hover', 'click']"
      >
        Resume Game
      </button>
    }

    <button
      class="btn btn-block"
      [class.btn-primary]="!hasStartedGame()"
      [class.btn-neutral]="hasStartedGame()"
      (click)="newGame()"
      appAnalyticsClick="Meta:Play:New"
      appSfx="ui-click"
      [sfxOffset]="0"
      [sfxTrigger]="['click', 'hover']"
    >
      New Game
    </button>

    <app-panel-debug-buttons></app-panel-debug-buttons>

    <app-button-settings></app-button-settings>

    <app-button-quit></app-button-quit>
  </div>

  <div class="left-0 right-0 pb-[48px]">
    <app-button-connect></app-button-connect>
  </div>
</div>

<div
  class="fixed bottom-0 left-0 right-0 bg-base-100 h-8 flex justify-center items-center text-sm"
>
  <span>Version {{ meta.versionString() }}</span>

  <span class="mx-2">&middot;</span>

  <button
    type="button"
    class="link link-hover"
    appAnalyticsClick="Meta:Settings:Analytics"
    (click)="openAnalyticsSettings()"
    appSfx="ui-click"
    [sfxTrigger]="['click', 'hover']"
  >
    Analytics: {{ analyticsEnabled() ? 'On' : 'Off' }}
  </button>

  <app-button-update></app-button-update>
</div>

<swal
  #newGameSwal
  title="Reset your game?"
  icon="warning"
  confirmButtonText="Yes, reset game"
  cancelButtonText="No, cancel"
></swal>

<swal
  #replaceUnloadableSwal
  title="Replace your savefile?"
  text="Your existing savefile couldn't be loaded. Starting a new game will overwrite it - try Recover Savefile first."
  icon="warning"
  confirmButtonText="Yes, start a new game"
  cancelButtonText="No, cancel"
></swal>

<ng-container [appTeleportOutlet]="'menu-options'"></ng-container>
